import useOfflineSync from "../../hooks/useOfflineSync";
import { SYNC_STATUS } from "../../offline/offlineSyncManager";
import "../../styles/offline-sync-status.css";

function formatWhen(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("en-IN");
  } catch {
    return String(value);
  }
}

export default function OfflineSyncStatus() {
  const sync = useOfflineSync();
  if (!sync.isOffline) return null;

  const showRetry =
    sync.status === SYNC_STATUS.FAILED ||
    (sync.status === SYNC_STATUS.SYNCING && sync.error);

  return (
    <section className="offline-sync-status" aria-live="polite">
      <div className="offline-sync-status__row">
        <strong className="offline-sync-status__badge">{sync.statusLabel}</strong>
        <span className="offline-sync-status__percent">{sync.percent}%</span>
      </div>
      <div
        className="offline-sync-status__bar"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={sync.percent}
      >
        <span style={{ width: `${sync.percent}%` }} />
      </div>
      <dl className="offline-sync-status__stats">
        <div>
          <dt>Total authorized</dt>
          <dd>{sync.total.toLocaleString("en-IN")}</dd>
        </div>
        <div>
          <dt>Synced</dt>
          <dd>{sync.synced.toLocaleString("en-IN")}</dd>
        </div>
        <div>
          <dt>Remaining</dt>
          <dd>{sync.remaining.toLocaleString("en-IN")}</dd>
        </div>
        <div>
          <dt>Last successful sync</dt>
          <dd>{formatWhen(sync.lastSuccessAt)}</dd>
        </div>
      </dl>
      {!sync.ready ? (
        <p className="offline-sync-status__warn">
          Complete vehicle dataset is not yet available offline. Search will only
          use records already saved on this device.
        </p>
      ) : (
        <p className="offline-sync-status__ok">
          Offline Ready. Vehicle records on this device can be searched without
          internet. Log out to remove them from this browser.
        </p>
      )}
      {sync.error ? (
        <p className="offline-sync-status__error">{sync.error}</p>
      ) : null}
      {showRetry ? (
        <button
          type="button"
          className="offline-sync-status__retry"
          onClick={sync.retry}
        >
          Retry / Resume
        </button>
      ) : null}
    </section>
  );
}
